// extracted by mini-css-extract-plugin
export default {"events":"Events_events__sGsZy","container":"Events_container__eHmfx"};